import { createApp } from 'vue'
import store from 'store'

import ConfiguratorTablist from './ConfiguratorTablist.vue'

const el = '.nti-component--configurator-tablist'
const DOM = document.querySelector(el)

const render = function(){
    if(DOM){
        const app = createApp(ConfiguratorTablist)
        app.use(store)
        app.mount(el)
    }
}

export default {
    render
}